import { MapPinIcon } from "@heroicons/react/24/outline";

interface LocationTextProps {
    value?: string;
    className?: string;
    iconClassName?: string;
  }

const LocationText: React.FC<LocationTextProps> = ({ 
  value,
  className = '',
  iconClassName = 'h-4 w-4 text-gray-400 flex-shrink-0 mr-1'
}) => {
    const getMapUrl = (location?: string): string => {
        if (!location) return '';
        return `https://maps.google.com/?q=${encodeURIComponent(location)}`;
      };

    
     return (
        <a
            href={getMapUrl(value)}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center hover:text-primary-600 transition-colors group ${className}`}
        >
            <MapPinIcon className={iconClassName} />
            <span className="truncate">{value}</span>
        </a>
     ) 
}

export default LocationText;